export const browserList = [
    {
        id: 1,
        browser_name: "Google Chrome",
        total_user: 90,
        iconColor:"primary",
        progressColor:"success",
        icon: "fa-chrome",
    },
    {
        id: 2,
        browser_name: "Mozila Firefox",
        total_user: 76,
        iconColor:"warning",
        progressColor:"primary",
        icon: "fa-firefox-browser"
    },
    {
        id: 3,
        browser_name: "Apple Safari",
        total_user: 50,
        iconColor:"info",
        progressColor:"warning",
        icon:"fa-safari"
    },
    {
        id: 4,
        browser_name: "Edge Browser",
        total_user: 20,
        iconColor:"success",
        progressColor:"secondary",
        icon:"fa-edge"
    },
    {
        id: 5,
        browser_name: "Opera mini",
        total_user: 15,
        iconColor:"danger",
        progressColor:"danger",
        icon:"fa-opera"
    },
    {
        id: 6,
        browser_name: "Internet Explorer",
        total_user: 12,
        iconColor:"explorer",
        progressColor:"teal",
        icon:"fa-internet-explorer"
    },
    {
        id: 7,
        browser_name: "Others Browser",
        total_user: 6,
        iconColor:"deploy",
        progressColor:"dark",
        icon:"fa-octopus-deploy"
    },

]